module.exports = __webpack_public_path__ + "img/qualityIndexScore4.2b1d3b44.png";